angular
  .module("myApp")
  .directive("zinatnesNozare", function zinatnesNozare() {
    return {
      restrict: "E",
      replace: true,
      templateUrl: "templates/nozares.directive.html",
      scope: {
        dto: "=ngModel",
        editMode: "=",
      },
      controller: "ZinatnesNozaresController as ctl",
    }
  })
  .controller("ZinatnesNozaresController", function (uuiData, $scope) {
    this.tmp = undefined
    this.used = {}
    this.assoc = {}

    this.nozares = uuiData.list(
      "zinatnes_nozares_choice",
      {
        valoda: "lv",
      },
      (ns) => {
        ns.forEach((n) => {
          this.assoc[n.id] = n.nosaukums
        })
      }
    )

    this.removeNozare = (d) => {
      const idx = $scope.dto.indexOf(d)

      if (idx !== -1) {
        $scope.dto.splice(idx, 1)
      }

      this.update_used()
    }

    this.addNozare = (nozare_id) => {
      if (!nozare_id) return

      if (!$scope.dto.some((e) => e.nozare_id === nozare_id)) {
        $scope.dto.push({ nozare_id })
        this.update_used()
      }
    }

    this.addNozareFromSelect = () => {
      this.addNozare(this.tmp)
      this.tmp = undefined
    }

    this.makePrimary = (d) => {
      const idx = $scope.dto.indexOf(d)

      if (idx !== -1) {
        $scope.dto.splice(idx, 1)
        $scope.dto.unshift(d)
      }

      this.update_used()
    }

    this.update_used = () => {
      Object.keys(this.used).forEach((k) => {
        this.used[k] = false
      })

      $scope.dto.forEach((e) => {
        this.used[e.nozare_id] = true
      })
    }
  })
